import { Checkbox } from "@mui/material";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { AlertInfo, CustomButton, DefaultLoader } from "../../components";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import { setLastAmountInvest } from "../fundSelectionStep2/redux/actions";
import {
  clearErrorInvestCheckout,
  clearInvestCheckoutLoading,
  investCheckout,
} from "../fundSelectionStep3/redux/actions";
import { getCustomer } from "../redux/action";
import "./style.summary.scss";
import { createGoalDL } from "../DeepLink/redux/action";
import { showError } from "../../globalRedux/actions";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { getPromoFromPayload } from "../../utils/functions/checkPromo";
import AccountVerificationPopup from "../../components/AccountVerificationPopup";

const riskDisclosure =
  "https://www.principal.com.my/en/ut-loan-financing-risk-my/mv";
const principalTnCPDF =
  "https://www.principal.com.my/sites/default/files/pdf-uploads/Principal%20Mini%20Program%20%28IMMF%20Class%20D%29%20Terms%20and%20Conditions.pdf";

function PlanSummary({
  fundsCode = [],
  investCheckout,
  investCheckoutLoading,
  history,
  investCheckoutError,
  showAccountVerificationError,
  clearErrorInvestCheckout,
  lastInvestAmount,
  profile,
  getCustomer,
  loading,
  clearInvestCheckoutLoading,
  selectedPromo,
  createGoal,
  getRetirementFundsHasError,
  retirementFunds,
  createGoalLoading,
  showError,
}) {
  const [isCheck, setCheck] = useState(false);

  const totalFundsAmount = Array.isArray(fundsCode)
    ? fundsCode.length * lastInvestAmount
    : 0;

  useEffect(() => {
    clearInvestCheckoutLoading();
    getCustomer();
  }, []);

  const handleSubmit = () => {
    dataLayerGTM(
      "click_tag",
      "Click",
      "Button",
      "Retirement Fund Cash In Summary - Continue"
    );

    const campaignCode = getPromoFromPayload(selectedPromo);

    const redirect = response => {
      investCheckout({
        cifPlanId: response.id,
        productId: response.productId,
        productCatCd: response.productCatCd,
        campaignCode,
        funds: [
          {
            fundCd: fundsCode[0].code,
            amount: totalFundsAmount,
            amountCcy: "MYR",
          },
        ],
        customerChannelCode: "Mini Program",
        amount: totalFundsAmount.toString(),
        ccy: "MYR",
        cifId: profile.masterId,
        name: profile.fullName,
        email: profile && profile.email,
      });
    };

    if (getRetirementFundsHasError) {
      const date = new Date();

      showError(
        "We are facing some technical issue, we're sorry for the inconvenience."
      );

      window.log({
        path: window.location.pathname,
        status: "400",
        res: {
          message: `GET /goal-creation/${
            profile.masterId
          }?type=MPRetire failed`,
        },
        req: {},
        requestDate: date,
        responseDate: date,
        responseTime: "0ms",
      });
      return;
    }

    if (Array.isArray(retirementFunds) && retirementFunds.length > 0) {
      const { id, product } = retirementFunds[0];
      redirect({
        id,
        productCatCd: product.productCatCd,
        productId: product.id,
      });
      return;
    }

    createGoal(
      {
        cifId: profile.masterId,
        invsPlanId: "160",
        planAlias: fundsCode[0]?.name,
        productId: fundsCode[0]?.id,
        targetAmount: String(fundsCode[0]?.clientCapturedAmount),
        term: "1",
        // unrelated property with the payload
        passWholeResponse: true,
      },
      redirect
    );
  };

  const handleNavigate = url => {
    window.my.navigateTo({
      url: "/pages/link/link?url=" + encodeURIComponent(url),
    });
  };

  const principalTnC = () => {
    window.my.showLoading();
    window.my.postMessage({
      api: "downloadFile",
      pdf: principalTnCPDF,
      event: "openPdf",
    });
  };

  if (investCheckoutLoading || loading || createGoalLoading)
    return <DefaultLoader />;

  return (
    <>
      <AlertInfo
        description="We are facing some technical issues, and we are working very hard to resolve the issue."
        isOpen={investCheckoutError && !showAccountVerificationError}
        isTimeout
        handleAction={() => {
          clearErrorInvestCheckout();
        }}
      />
      <AccountVerificationPopup
        isOpen={investCheckoutError && showAccountVerificationError}
        onChat={clearErrorInvestCheckout}
        onClose={clearErrorInvestCheckout}
        title="Information Verification"
      />
      <div className="l-retired-summary deposit-wrapper">
        <div className="back-btn-wrapper">
          <ArrowBackOutlinedIcon
            sx={{ fontSize: 24, color: "#0091da" }}
            onClick={() => {
              dataLayerGTM(
                "click_tag",
                "Click",
                "Button",
                "Fund Cash In Summary - back button"
              );
              history.back();
            }}
          />
          <h4 className="l-retired-summary__title">Your Investment Summary</h4>
        </div>
      </div>

      <div>
        {fundsCode.map((item, index) => (
          <div className="l-retired-summary__content" key={index}>
            <h2>{item.name}</h2>
            <div>
              <p style={{ display: "flex", justifyContent: "space-between" }}>
                Inclusive sales charge of{" "}
                <span>
                  {item.salesCharge ||
                    process.env.REACT_APP_RETIREMENT_SALES_CHARGE.trim()}
                  %
                </span>
              </p>
              <p>
                ({item.serviceTaxPerc || 0}% SST applicable on Sales Charge)
              </p>
              {/* START: Campaign related changes */}
              <h4>
                {Object.keys(selectedPromo).length > 0 && (
                  <>
                    <span>{selectedPromo.name}</span>
                    <span>-</span>{" "}
                  </>
                )}
              </h4>
              {/* END: Campaign related changes */}
            </div>
          </div>
        ))}
      </div>

      <div className="l-retired-summary-recipe">
        <p className="l-retired-summary-recipe__label">Total Cash In</p>
        <p className="l-retired-summary-recipe__amount">
          RM{" "}
          <NumberFormat
            value={totalFundsAmount}
            thousandSeparator
            displayType="text"
            decimalScale={2}
            fixedDecimalScale={true}
          />
        </p>
      </div>
      <div className="l-retired-summary__terms">
        <Checkbox
          checked={isCheck}
          onChange={() => setCheck(!isCheck)}
          color="primary"
          sx={{
            margin: 0,
            padding: "0px !important",
            paddingTop: 0.5,
            "& .MuiSvgIcon-root": { fontSize: 24 },
          }}
        />
        <div className="l-retired-summary__terms-text">
          <p style={{ marginBottom: "8px" }}>
            I have read and agreed to{" "}
            <span onClick={principalTnC}>Principal’s Terms & Conditions</span>,
            the Unit Trust Loan Financing{" "}
            <span onClick={() => handleNavigate(riskDisclosure)}>
              Risk Disclosure Statement
            </span>
            , and have read and understood the relevant Prospectus, Information
            Memorandum and/or Disclosure Document including any supplemental
            thereof and the Product Highlight Sheet (if any) before Investing.
          </p>
          <p>
            I acknowledge the investment risk, and aware that the fund is not
            E-money, deposit, or capital guaranteed/protected by PIDM. Losses
            are not covered by the Capital Market Compensation Fund.
          </p>
          <p style={{ marginTop: "8px" }}>
            Please note that your investment amount is subjected to charges
            imposed by Private Pension Administrator (PPA). Any application
            received after 12:00 p.m. will be processed on the next Business
            Day.
          </p>
        </div>
      </div>

      <div className="l-retired-summary__confirm">
        <CustomButton
          text="Cash In"
          variant="contained"
          color="#fff"
          backgroundColor="#1278CC"
          disabled={!isCheck || investCheckoutLoading}
          onClick={handleSubmit}
        />
      </div>
    </>
  );
}

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    profile: state.goal.profile,
    fundsCode: state.fundSelectionReducer.fundsCode,
    investCheckoutLoading: state.investCheckoutReducer.investCheckoutLoading,
    lastInvestAmount: state.investPortfolioReducer.lastInvestAmount,
    investCheckoutError: state.investCheckoutReducer.investCheckoutError,
    showAccountVerificationError:
      state.investCheckoutReducer.showAccountVerificationError,
    createGoalLoading: state.deeplinkReducer.createGoalDLLoading,
    getRetirementFundsHasError: state.goal.getRetirementFundsHasError,
    retirementFunds: state.goal.retirementFunds,
    ...state.promoReducer,
  }),
  {
    investCheckout,
    clearErrorInvestCheckout,
    setLastAmountInvest,
    getCustomer,
    clearInvestCheckoutLoading,
    createGoal: createGoalDL,
    showError,
  }
);

export default compose(
  withRouter,
  withConnect
)(PlanSummary);
